<template>
    <div :class="['block block-quote',(json.bg) ? 'img' : '']" >
        <div v-if="json.bg" class="bg" v-sr >
            <img :src="json.bg"/>
        </div>
        <div v-if="json.bg" class="cap-padded-2x">
            <div class="quote-holder" v-sr >
                <div class="quote-copy">
                    <div class="quote-icon">
                        <QuoteWhite/>
                    </div>
                    <div class="quote-copy2">
                        <div class="quote" v-html="json.quote"></div>
                        <div class="name" v-html="json.name"></div>
                        <div class="attribute" v-html="json.attribute"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="no-img" >
            <div class="quote-holder" v-sr >
                <div class="quote-icon show-desktop">
                    <QuoteThin/>
                </div>
                <div class="quote-icon show-mobile">
                    <QuoteThinMobile/>
                </div>
                <div class="quote-copy">
                    <div class="quote-copy1">
                        <div class="cap-padded-2x">
                            <div class="quote-copy2">
                                <div class="quote" v-html="json.quote"></div>
                                <div class="name" v-html="json.name"></div>
                                <div class="attribute" v-html="json.attribute"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QuoteWhite from '@/components/svgs/QuoteWhite'
import QuoteThin from '@/components/svgs/QuoteThin'
import QuoteThinMobile from '@/components/svgs/QuoteThinMobile'
export default {
    name: "QuoteGeneric",
    components: {
        QuoteWhite,
        QuoteThin,
        QuoteThinMobile
    },
    props: {
        json: {
            type: Object,
            required: true,
            default: null,
        },
    },

}
</script>
